$(function () {
    $(document).on('lazyLoadCompleteLoaded', function () {
        trackViewItemlist();
    });
});

function trackSubProductSelection() {
    let selectedSubProductId = $('#subservice_id').val();
    let selectedSubProduct = getCurrentSubproduct(selectedSubProductId);
    let formData = getServiceFormData();
    let peopleQuantity = parseFloat(formData['people_quantity_adult']) + parseFloat(formData['people_quantity_youth']) + parseFloat(formData['people_quantity_children']);

    dataLayer.push({
        'event': 'select_item',
        'ecommerce': {
            'items': [{
                affiliation: 'krakowdirect.com',
                item_brand: 'KD-WWW',
                item_id: selectedSubProduct.service_code,
                item_name: selectedSubProduct.name,
                item_variant: selectedSubProduct.name_translated,
                item_category: selectedSubProduct.service_type,
                item_category2: formData['pickup_type'],
                item_category3: formData['tour_date'],
                item_category4: formData['private_or_group'],
                item_category5: formData['tour_lang'],
                item_list_id: "service_id_" + selectedSubProduct.parent_service_id,
                item_list_name: selectedSubProduct.name,
                price: $('#totalPrice').text().trim(),
                quantity: peopleQuantity,
            }]
        }
    })
}

function trackAddToCart(orderData) {
    var formData = {};
    var serializedFormData = $(this).serializeArray();
    $(serializedFormData).each(function (index, obj) {
        formData[obj.name] = obj.value;
    });

    let orderPrice = currentCurrency === 'PLN' ? orderData.price_pln : orderData.price_eur;
    dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'items': [{
                'item_id': orderData.service_id,
                'item_name': orderData.service_name,
                'affiliation': 'krakowdirect.com',
                'currency': currentCurrency,
                'discount': 0,
                'index': 1,
                'item_brand': 'KD-WWW',
                'item_category': orderData.service_type,
                'item_category2': orderData.people_quantity,
                'item_category3': orderData.pick_up_type,
                'item_category4': orderData.date,
                'item_category5': orderData.language,
                'item_category6': orderData.private_or_group,
                'item_variant':  1,
                'price': orderPrice,
                'quantity': 1
            }]
        }
    })
}

function trackViewItem(serviceId) {
    let selectedSubProduct = getCurrentSubproduct(serviceId);
    let formData = getServiceFormData();
    let peopleQuantity = parseFloat(formData['people_quantity_adult']) + parseFloat(formData['people_quantity_youth']) + parseFloat(formData['people_quantity_children']);

    dataLayer.push({
        'event': 'view_item',
        'ecommerce': {
            'items': [
                {
                    affiliation: 'krakowdirect.com',
                    item_brand: 'KD-WWW',
                    item_id: selectedSubProduct.service_code,
                    item_name: selectedSubProduct.name,
                    item_variant: selectedSubProduct.name_translated,
                    item_category: selectedSubProduct.service_type,
                    item_category2: formData['pickup_type'],
                    item_category3: formData['tour_date'],
                    item_category4: formData['private_or_group'],
                    item_category5: formData['tour_lang'],
                    item_list_id: "service_id_" + selectedSubProduct.parent_service_id,
                    item_list_name: selectedSubProduct.name,
                    price: $('#totalPrice').text().trim(),
                    quantity: peopleQuantity,
                }
            ]
        }
    })
}

function trackViewItemlist() {
    if (typeof (servicesList) === 'undefined' || typeof (servicesListType) === 'undefined') {
        return;
    }

    let ecommerceItems = [];
    servicesList.forEach(function (service) {
        ecommerceItems.push({
            item_id: service.api_key,
            item_name: service.title,
            affiliation: "krakowdirect.com",
            item_brand: "KD-WWW",
            item_category: service.service_template,
            item_category2: service.private_or_group,
            price: 'FROM ' + service.price_from,
        })
    });

    dataLayer.push({
        'event': 'view_item_list',
        'ecommerce': {
            item_list_id: servicesListType + "_list",
            item_list_name: servicesListType + " list",
            items: ecommerceItems
        }
    })
}

function getCurrentSubproduct(subproductId) {
    return currentSubproducts.find(function (subproduct) {
        return subproduct.service_id == subproductId;
    });
}

function getServiceFormData() {
    let formData = {};
    let serializedFormData = $('#serviceOrderForm').serializeArray();
    $(serializedFormData).each(function (index, obj) {
        formData[obj.name] = obj.value;
    });

    return formData;
}

module.exports = {
    trackSubProductSelection,
    trackAddToCart,
    trackViewItem,
    trackViewItemlist
};
